import type { BusinessUnit } from '@backend/lib-l10n';

import { businessUnits } from '~/config/businessUnits';
import { locales } from '~/locales';
import { getDefaultBusinessUnit } from '~/utils/businessUnit';
import type { Translations } from '~/utils/translations/types';

export const getTranslations = (businessUnit: BusinessUnit) =>
  (locales[businessUnits[businessUnit].language] ||
    locales[businessUnits[getDefaultBusinessUnit()].language] ||
    {}) as Translations;
